import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import SimpleTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SimpleTooltip';
import Checkbox from '@wix/da-ds/pkg/Checkbox';
import {
  ThemeOverride,
  ThemeSurface,
} from '@wix/da-react-context/pkg/ThemeContext';
import Pagination from '../../../StudioPagination';
import { SelectionProps } from '../../types';

import s from './SelectionArea.scss';

interface Props extends SelectionProps {
  className?: string;
}

const SelectionArea: FC<Props> = ({
  className,
  allIsSelected,
  canSelect,
  selectedCount = 0,
  onSelect,
}) => {
  const { t } = useTranslation();
  const hasSelection = selectedCount > 0;

  const checkbox = (
    <Checkbox
      onChange={onSelect}
      isChecked={allIsSelected}
      disabled={!canSelect}
    />
  );

  return (
    <ThemeOverride
      themeSurface={ThemeSurface.SECONDARY}
      className={cn(s['root'], className)}
      tag="div"
    >
      {canSelect ? (
        <SimpleTooltip
          text={t('studio.table.header.selectAll.tooltip')}
          usePortal
        >
          {checkbox}
        </SimpleTooltip>
      ) : null}

      {!hasSelection && <Pagination showButtons={false} />}
      {hasSelection && (
        <span className={s['selected-count']}>
          {t('studio.table.header.selectedCount', { count: selectedCount })}
        </span>
      )}
    </ThemeOverride>
  );
};
SelectionArea.displayName = 'SelectionArea';

export default SelectionArea;
